var EJS = require("./ejs");
var $ = require("jquery");
require('es6-promise').polyfill();
var fetch = require("whatwg-fetch");
// var JSON = require("./json2");
var Utils = require("../../../utils/index");

var NODE_ENV = process.env.NODE_ENV;
var base = {
    //渲染模板src:模板ID target:页面容器ID data:渲染数据 type:渲染方式
    render: Utils.renderHtml,
    // render: function(src, target, data, type) {
    //     type = type || "all";
    //     data = data || {};
    //     var tmpl = $(src).innerText || $(src)[0].innerText || $(src)[0].innerHTML;
    //     tmpl = tmpl.replace(/\<\%\=\s*include\((.*?)\)\s*\%\>/g, function(a, b) {
    //         b = b.replace(/'|"/g, '');
    //         return $(b).innerText || $(b)[0].innerText || $(b)[0].innerHTML;
    //     });
    //     var obj = new EJS({
    //         text: tmpl
    //     });
    //     var html = obj.render(data);
    //     $(target).html(html);
    // },
    //弹窗
    popbox: function (opt) {
        var that = this;
        var defaultOpt = {
            h_title: "", //弹窗title
            body: '', //弹窗主体html 使用$('<div>').append(tmpl).html(),
            width: 800,
            top: 60,
            dialog_id: 'dialog_' + that.getRandom(), //dialog 唯一标示符
            data: {
                filePath: "",
                accountName: "",
                transactionDate: "",
                accountNumber: ""
            },
            callback: null, //弹窗渲染完毕后的回调
            beforeclose: null, //弹窗关闭之前的函数
            close: function (opt) {
                if (opt) {
                    $("#" + opt.dialog_id).remove();
                }
            }, //弹窗关闭函数
            buttons: [{
                'name': 'ok',
                'className': '',
                'click': null
            }] //弹窗底部按钮
        };

        opt = $.extend(defaultOpt, opt || {});
        $("body").addClass("modal-open");
        that.render("#popbox-tmpl", "body", opt, "append");
        $("body").append($('<div class="dialog-backdrop">'));

        if (opt.body) {
            that.render(opt.body, '#' + opt.dialog_id + " .modal-body", opt);
        }

        $('#' + opt.dialog_id).css({
            'width': opt.width + 'px',
            'top': opt.top + 'px',
            'left': function () {
                if (that.getWinWidth() <= opt.width) {
                    return '0px';
                } else {
                    return (that.getWinWidth() - opt.width) / 2 + 'px';
                }
            }
        });
        var dialog = $('#' + opt.dialog_id).find('.modal-content');
        $.each(opt.buttons, function (i, e) {
            var btn = $('<button id="btn_' + i + '" class="btn ' + e.className + '">' + e.name + '</button>');
            if (typeof e.click == 'function') {
                btn.on('click', e.click).data('opt', opt).appendTo(dialog.find('.modal-footer'));
            } else {
                btn.data('opt', opt).appendTo(dialog.find('.modal-footer'));
            }
        });
        dialog.on('close', function () {
            opt.close && opt.close.call(this, opt);
        });

        dialog.on('beforeclose', function () {
            opt.beforeclose && opt.beforeclose.call(this, opt);
        });

        $('#' + opt.dialog_id).show();
        $('.dialog-backdrop').show();
        $('#' + opt.dialog_id).fadeIn(300, function () {
            if (typeof opt.callback == 'function') {
                opt.callback(opt);
            }

            $('#' + opt.dialog_id + ' .close').on('click', function () {
                that.closePopBox(dialog, opt);
                return false;
            });
            // $('#' + opt.dialog_id).on('click', function(e) {
            //     that.closePopBox(this, opt);
            //     that.stopBubble(e);
            // });
        });
    },
    //关闭弹窗
    closePopBox: function (dialog, opt) {
        function closeCallBack() {
            $(this).trigger('beforeclose');
            $('body').removeClass('modal-open');
            $(this).trigger('close');
        }
        $(dialog).fadeOut(300, function () {
            $('.dialog-backdrop').hide();
            closeCallBack.call(this);
        });
    },
    //停止冒泡
    stopBubble: function (e) {
        try {
            e.stopPropagation;
        } catch (err) {
            e.cancelBubble == true;
        }
    },
    getRandom: function () {
        return Math.random().toString(16).substring(2);
    },
    getToken: function () {
        var that = this;
        var token = base.getParameterByName().token;
        that.cookie("token", token);
        return token;
    },
    //获取URL参数 以对象返回
    getParameterByName: function () {
        var match,
            urlParams = {},
            pl = /\+/g,
            // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
            decode = function (s) {
            return decodeURIComponent(s.replace(pl, " "));
        },
            query = window.location.search.substring(1);

        while (match = search.exec(query)) urlParams[decode(match[1])] = decode(match[2]);

        return urlParams;
    },
    getQueryObject: function () {
        var search = window.location.search.substring(1);
        var obj = {};
        var reg = /([^?&=]+)=([^?&=]*)/g;
        search.replace(reg, function (rs, $1, $2) {
            var name = decodeURIComponent($1);
            var val = decodeURIComponent($2);
            val = String(val);
            obj[name] = val;
            return rs;
        });
        return obj;
    },

    //获取cookie
    cookie: function (name, value, options) {
        if (typeof value != 'undefined') {
            // name and value given, set cookie
            options = options || {};
            if (value === null) {
                value = '';
                options.expires = -1;
            }
            var expires = '';
            if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
                var date;
                if (typeof options.expires == 'number') {
                    date = new Date();
                    date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
                } else {
                    date = options.expires;
                }
                expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
            }
            // CAUTION: Needed to parenthesize options.path and options.domain
            // in the following expressions, otherwise they evaluate to undefined
            // in the packed version for some reason...
            var path = options.path ? '; path=' + options.path : '';
            var domain = options.domain ? '; domain=' + options.domain : '';
            var secure = options.secure ? '; secure' : '';
            document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
        } else {
            // only name given, get cookie
            var cookieValue = null;
            if (document.cookie && document.cookie != '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = $.trim(cookies[i]);
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) == name + '=') {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        }
    },
    //对于所有ajax做处理
    ajaxSetup: function ($) {
        var that = this;
        // 加入防止CSRF token的代码
        $.ajaxSetup({
            beforeSend: function () {
                var dataType = this.dataType || this.datatype || '';
                dataType = dataType.toLowerCase();
                if (dataType == 'json') {
                    var token = that.cookie('_tb_token_') || '';
                    if (this.hasContent) {
                        // POST/PUT等方法
                        var data = this.data || '';
                        if (data) {
                            data = data + '&';
                        }
                        data = data + '_tb_token_=' + token;
                        this.data = data;
                    } else {
                        // GET/HEAD等方法
                        var url = this.url || '';
                        if (url.indexOf('?') == -1) {
                            url = url + '?';
                        } else {
                            url = url + '&';
                        }
                        url = url + '_tb_token_=' + token;
                        this.url = url;
                    }
                }
            }
        });
    },
    //上传文件
    uploadFile: function (ele) {
        var that = this;

        $("#UpladContainer").off("load").on("load", function (e) {
            var responseText = that.getResponseText(this); //$(this).contents();

            $("#showImg").attr("src", responseText.url);
            $("#imgfull").val(responseText.url);
            $(".cover").attr("src", "https://img.alicdn.com/tps/TB1S_PBMVXXXXarXpXXXXXXXXXX-361-200.png");
            $(".upload-container").hide().closest(".pro-box").off("mouseover").off("mouseleave").on("mouseover", function () {
                $(".upload-container").show();
            }).on("mouseleave", function () {
                $(".upload-container").hide();
            });
        });

        $(ele).closest("form").submit();
    },
    getResponseText: function (frame) {
        var doc = frame.contentWindow ? frame.contentWindow.document : frame.contentDocument ? frame.contentDocument : frame.document;
        var docRoot = doc.body ? doc.body : doc.documentElement;
        var responseText = $.trim($(docRoot).text());
        responseText = !!responseText ? JSON.parse(responseText) : "";
        return responseText;
    },
    checkApplyStatus: function (applyStatus, accStatus) {
        var that = this;
        var token = that.cookie("token");
        if (+applyStatus != +accStatus) {
            switch (+applyStatus) {
                case 1:
                    window.location.href = "/protocol?token=" + token;
                    break;
                case 2:
                    window.location.href = "/apply?token=" + token;
                    break;
                case 3:
                    window.location.href = "/payAli?token=" + token;
                    break;
                case 4:
                    window.location.href = "/showBill?token=" + token;
                    break;
                case 5:
                    window.location.href = "/paySuccess?token=" + token;
                    break;
            }
        }
    },
    getWinWidth: function () {
        var winWidth = 0;
        if (window.innerWidth) {
            winWidth = window.innerWidth;
        } else if (document.body && document.body.clientWidth) {
            winWidth = document.body.clientWidth;
        }
        return winWidth;
    },
    getWinHeight: function () {
        var winHeight = 0;
        if (window.innerHeight) {
            winHeight = window.innerHeight;
        } else if (document.body && document.body.clientHeight) {
            winHeight = document.body.clientHeight;
        }
        return winHeight;
    },
    request: function (params, config) {
        var api = config.api || "",
            v = config.v || "1.0",
            ecode = config.ecode || 1;
        switch (NODE_ENV) {
            case 'local':
                //使用mock数据
                return window.fetch('http://rap.alibaba-inc.com/mockjsdata/1720/' + api, {
                    mode: 'cors'
                }).then(function (response) {
                    return response.json();
                });
            case 'development':
                //调用日常接口 api.waptest.mashangfangxin.com
                lib.mtop.config.subDomain = "waptest";
                return lib.mtop.H5Request({
                    AntiCreep: true, // 防爬 
                    api: api,
                    v: v,
                    data: params,
                    ecode: ecode
                });
            default:
                //线上接口 http协议使用api.m.mashangfangxin.com，https协议使用api2.mashangfangxin.com
                if (window.location.protocol.indexOf("https") > -1) {
                    lib.mtop.config.prefix = 'api2';
                    lib.mtop.config.mainDomain = 'mashangfangxin.com'; // mtop的主域
                    lib.mtop.config.subDomain = "";
                } else {
                    lib.mtop.config.mainDomain = 'mashangfangxin.com'; // mtop的主域
                    lib.mtop.config.subDomain = "m";
                }
                //记录日志
                //customRecord(config.api, params);
                return lib.mtop.H5Request({
                    AntiCreep: true, // 防爬 
                    api: api,
                    v: v,
                    data: params,
                    ecode: ecode
                });
        }
    },
    sendRequest: function (arr, callback, error) {
        var that = this;
        var startTime = +new Date();
        var request = [];

        for (var i = 0; i < arr.length; i++) {
            request.push(that.request(arr[i].postData, arr[i].config));
        }
        Promise.all(request).then(function (data) {
            for (var i = 0; i < data.length; i++) {
                if (data[i].ret && data[i].ret[0]) {
                    var endTime = +new Date();
                    var res = data[i].ret[0].split('::');
                    switch (data[i].ret[0].indexOf("SUCCESS") > -1) {
                        case true:
                            window.record && window.record(arr[i].config.api, true, endTime - startTime, arr[i].postData, res[0] || '', data[i].data || '');
                            break;
                        case false:
                            window.record && window.record(arr[i].config.api, false, endTime - startTime, arr[i].postData, res[0] || '', res[1] || '');
                            break;
                    }
                }
            }
            callback(data);
        }, function (err) {
            if (err.ret && err.ret[0] && err.ret[0].indexOf("FAIL_SYS_SESSION_EXPIRED") > -1) {
                that.doLogin();
            } else if (err.ret && err.ret[0]) {
                var res = err.ret[0].split('::');
                var postData;
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].config.api == err.api) {
                        postData = arr[i].postData;
                    }
                }
                var endTime = +new Date();
                record(err.api, false, endTime - startTime, postData, res[0] || '', res[1] || '');
                error(err);
            }
        });
    }
};

module.exports = base;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/home/lib-js/base.js
 ** module id = 10
 ** module chunks = 1 2 12
 **/